
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4zyjT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9DHhW = parcelRequire("9DHhW");


var $dinVW = parcelRequire("dinVW");


var $hMjUh = parcelRequire("hMjUh");


var $dkVNA = parcelRequire("dkVNA");


var $gRGWz = parcelRequire("gRGWz");


var $eBTV9 = parcelRequire("eBTV9");











var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $eq2ng = parcelRequire("eq2ng");

const $8a8738e9c94c1af0$var$baseStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-neutral, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    borderRadius: 'radius.full',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $8a8738e9c94c1af0$var$selectedStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    borderRadius: 'radius.full',
    color: 'color.text.selected',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $8a8738e9c94c1af0$export$78d15021d44428c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const tabAttributes = (0, $eq2ng.default)();
    const isTabSelected = tabAttributes["aria-selected"];
    let tabAttributesWithoutControls;
    if ($[0] !== tabAttributes) {
        const { "aria-controls": _ariaControls, ...t1 } = tabAttributes;
        tabAttributesWithoutControls = t1;
        $[0] = tabAttributes;
        $[1] = tabAttributesWithoutControls;
    } else tabAttributesWithoutControls = $[1];
    const t1 = isTabSelected ? $8a8738e9c94c1af0$var$selectedStyles : $8a8738e9c94c1af0$var$baseStyles;
    let t2;
    if ($[2] !== label || $[3] !== t1 || $[4] !== tabAttributesWithoutControls) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t1,
            ...tabAttributesWithoutControls,
            role: "tab"
        }, label);
        $[2] = label;
        $[3] = t1;
        $[4] = tabAttributesWithoutControls;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ label: label })=>{
    const tabAttributes = (0, $eq2ng.default)();
    const isTabSelected = tabAttributes['aria-selected'];
    const { 'aria-controls': _ariaControls, ...tabAttributesWithoutControls } = tabAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: isTabSelected ? $8a8738e9c94c1af0$var$selectedStyles : $8a8738e9c94c1af0$var$baseStyles,
        ...tabAttributesWithoutControls,
        role: "tab"
    }, label);
};


const $4fb66089c5395ba8$var$tabsListStyles = null;
const $4fb66089c5395ba8$export$1f2189c52356e986 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { source: source, tabSections: tabSections, onTabClick: onTabClick, selected: selected } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onTabClick || $[2] !== source || $[3] !== tabSections) {
        t1 = (index)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "tab",
                    actionSubjectId: "configPanelNavigationPills",
                    source: source,
                    attributes: {
                        selectedValue: tabSections[index].value
                    }
                }
            }).fire();
            onTabClick?.(tabSections[index], index);
        };
        $[0] = createAnalyticsEvent;
        $[1] = onTabClick;
        $[2] = source;
        $[3] = tabSections;
        $[4] = t1;
    } else t1 = $[4];
    const handleTabClick = t1;
    const configPanelRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (configPanelRef.current) {
                const firstTab = configPanelRef.current.querySelector("[role=\"tab\"]");
                if (firstTab) firstTab.focus();
            }
        };
        t3 = [];
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = `${source}-config-panel-tabs`;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_1wydGWkG2W _3jAIaU1Y8M _1kMgZaZqHV _4dC4lYZqHV _3fyuLJZqHV _235xMVZqHV"
        ]);
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== tabSections) {
        t6 = tabSections.map($4fb66089c5395ba8$var$_temp);
        $[8] = tabSections;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: configPanelRef,
            className: t5
        }, /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, t6));
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== source || $[13] !== tabSections) {
        let t9;
        if ($[15] !== source) {
            t9 = (tab_0, index_1)=>/*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), {
                    key: index_1
                }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    grow: "fill",
                    testId: "tab-panel-content"
                }, tab_0.tabContent.map((section)=>section.defaultIsExpanded !== undefined && section.title ? /*#__PURE__*/ $cozmU.createElement((0, $eBTV9.CollapsibleItem), {
                        key: section.sectionId,
                        title: section.title,
                        section: section.sectionId,
                        defaultIsExpanded: section?.defaultIsExpanded,
                        source: source
                    }, section.component) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                        key: section.sectionId
                    }, section.component))));
            $[15] = source;
            $[16] = t9;
        } else t9 = $[16];
        t8 = tabSections.map(t9);
        $[12] = source;
        $[13] = tabSections;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[17] !== handleTabClick || $[18] !== selected || $[19] !== t4 || $[20] !== t7 || $[21] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
            id: t4,
            onChange: handleTabClick,
            selected: selected
        }, t7, t8);
        $[17] = handleTabClick;
        $[18] = selected;
        $[19] = t4;
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : ({ source: source, tabSections: tabSections, onTabClick: onTabClick, selected: selected })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleTabClick = (0, $cozmU.useCallback)((index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: 'configPanelNavigationPills',
                source: source,
                attributes: {
                    selectedValue: tabSections[index].value
                }
            }
        }).fire();
        onTabClick?.(tabSections[index], index);
    }, [
        createAnalyticsEvent,
        tabSections,
        source,
        onTabClick
    ]);
    const configPanelRef = (0, $cozmU.useRef)(null); // Focus the first tab when the config panel opens
    (0, $cozmU.useEffect)(()=>{
        if (configPanelRef.current) {
            const firstTab = configPanelRef.current.querySelector('[role="tab"]');
            if (firstTab) firstTab.focus();
        }
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, $hMjUh.default), {
        id: `${source}-config-panel-tabs`,
        onChange: handleTabClick,
        selected: selected
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        ref: configPanelRef,
        className: (0, $hekY6.default)([
            "_1wydGWkG2W _3jAIaU1Y8M _1kMgZaZqHV _4dC4lYZqHV _3fyuLJZqHV _235xMVZqHV"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dkVNA.default), null, tabSections.map((tab, index_0)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $8a8738e9c94c1af0$export$78d15021d44428c), {
            key: index_0,
            label: tab.label
        });
    }))), tabSections.map((tab_0, index_1)=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $gRGWz.default), {
            key: index_1
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            grow: "fill",
            testId: "tab-panel-content"
        }, tab_0.tabContent.map((section)=>section.defaultIsExpanded !== undefined && section.title ? /*#__PURE__*/ $cozmU.createElement((0, $eBTV9.CollapsibleItem), {
                key: section.sectionId,
                title: section.title,
                section: section.sectionId,
                defaultIsExpanded: section?.defaultIsExpanded,
                source: source
            }, section.component) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
                key: section.sectionId
            }, section.component))));
    }));
};
function $4fb66089c5395ba8$var$_temp(tab, index_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, $8a8738e9c94c1af0$export$78d15021d44428c), {
        key: index_0,
        label: tab.label
    });
}
module.exports["ConfigPanelGrouping"] = $4fb66089c5395ba8$export$1f2189c52356e986;

});

parcelRegister("eBTV9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $kA6Zo = parcelRequire("kA6Zo");

var $kh0hi = parcelRequire("kh0hi");

var $2wCqQ = parcelRequire("2wCqQ");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");

const $5585d41b7b3e5e2a$var$pressableStyles = (0, $buxP3.xcss)({
    background: 'none',
    height: 'space.300',
    paddingInline: 'space.100',
    paddingBlock: 'space.200'
});
const $5585d41b7b3e5e2a$var$wrapperStyles = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $5585d41b7b3e5e2a$var$expandedContainerStyles = (0, $buxP3.xcss)({
    paddingBottom: 'space.200',
    paddingInline: 'space.100'
});
const $5585d41b7b3e5e2a$export$1df80d75edaa7a50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { title: title, defaultIsExpanded: defaultIsExpanded, section: section, children: children, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultIsExpanded ?? false);
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t1 = (newState, section_0)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "collapsible",
                    actionSubjectId: "configPanelSectionCollapsible",
                    source: source,
                    attributes: {
                        section: section_0,
                        action: newState ? "expanded" : "collapsed"
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t1;
    } else t1 = $[2];
    const handleSectionClickAnalytics = t1;
    let t2;
    if ($[3] !== handleSectionClickAnalytics || $[4] !== isExpanded || $[5] !== section) {
        t2 = ()=>{
            handleSectionClickAnalytics(!isExpanded, section);
            setIsExpanded(!isExpanded);
        };
        $[3] = handleSectionClickAnalytics;
        $[4] = isExpanded;
        $[5] = section;
        $[6] = t2;
    } else t2 = $[6];
    const handleClick = t2;
    let t3;
    if ($[7] !== title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
            size: "medium",
            weight: "semibold"
        }, title);
        $[7] = title;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== isExpanded) {
        t4 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        });
        $[9] = isExpanded;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            justifyContent: "space-between"
        }, t3, t4);
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== handleClick || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
            onClick: handleClick,
            xcss: $5585d41b7b3e5e2a$var$pressableStyles,
            testId: "collapsible-item"
        }, t5);
        $[14] = handleClick;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== children || $[18] !== isExpanded) {
        t7 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.100",
            xcss: $5585d41b7b3e5e2a$var$expandedContainerStyles
        }, children);
        $[17] = children;
        $[18] = isExpanded;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== t6 || $[21] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: "space.100",
            xcss: $5585d41b7b3e5e2a$var$wrapperStyles
        }, t6, t7);
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
} : ({ title: title, defaultIsExpanded: defaultIsExpanded, section: section, children: children, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultIsExpanded ?? false);
    const handleSectionClickAnalytics = (0, $cozmU.useCallback)((newState, section_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'collapsible',
                actionSubjectId: 'configPanelSectionCollapsible',
                source: source,
                attributes: {
                    section: section_0,
                    action: newState ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleClick = ()=>{
        handleSectionClickAnalytics(!isExpanded, section);
        setIsExpanded(!isExpanded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100",
        xcss: $5585d41b7b3e5e2a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        onClick: handleClick,
        xcss: $5585d41b7b3e5e2a$var$pressableStyles,
        testId: "collapsible-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), {
        size: "medium",
        weight: "semibold"
    }, title), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100",
        xcss: $5585d41b7b3e5e2a$var$expandedContainerStyles
    }, children));
};
module.exports["CollapsibleItem"] = $5585d41b7b3e5e2a$export$1df80d75edaa7a50;

});

parcelRegister("5ddnJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yUlE = parcelRequire("4yUlE");

const $bb2356378f651040$export$740dd80d7ba80184 = (backgroundColor, isReadableForegroundColor, foregroundColor, updateForegroundColor, defaultParameters)=>{
    (0, $cozmU.useEffect)(()=>{
        // No need to do autotransition when background color is same as default BackgroundColor, e.g. theme color
        if (!isReadableForegroundColor(foregroundColor) && backgroundColor !== defaultParameters?.backgroundColor) {
            const textColorToken = (0, $4yUlE.extractToken)(foregroundColor);
            if (textColorToken === (0, $4yUlE.extractToken)("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            else if (textColorToken === (0, $4yUlE.extractToken)("var(--ds-text-inverse, #FFFFFF)")) updateForegroundColor("var(--ds-text, #292A2E)");
            else if (foregroundColor === defaultParameters?.textColor) {
                if (isReadableForegroundColor("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text, #292A2E)");
                else updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backgroundColor
    ]);
};
module.exports["useAutoTransitioningColors"] = $bb2356378f651040$export$740dd80d7ba80184;

});

parcelRegister("1ipaC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $9l2Y4 = parcelRequire("9l2Y4");


var $2TDGa = parcelRequire("2TDGa");




const $4037714a7b5ad056$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cornerStyle: {
        id: "company-hub.company-hub-common.links-menu.corner.style",
        defaultMessage: "Corner style"
    },
    roundCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-round",
        defaultMessage: "Round"
    },
    squareCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-square",
        defaultMessage: "Square"
    }
});


const $e3c7c5ec27e4fc8e$var$styles = {
    borderOptionContainer: "_4c065UFQfX _2Y7lL41Y8M _0KLXru7Cj1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VoWWg _39xV02oWWg",
    border: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8",
    selected: "_3vBAKHQvmT _0KLXruY9q9"
};
const $e3c7c5ec27e4fc8e$export$b2197740663fbf1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { cornerStyleValue: cornerStyleValue, updateCornerStyle: updateCornerStyle, roundCornerValue: roundCornerValue, squareCornerValue: squareCornerValue } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== updateCornerStyle) {
        t1 = (cornerOption)=>updateCornerStyle(cornerOption);
        $[0] = updateCornerStyle;
        $[1] = t1;
    } else t1 = $[1];
    const handleCornerOptionClick = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4037714a7b5ad056$export$defe85febe8b728c).cornerStyle));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== cornerStyleValue || $[4] !== formatMessage || $[5] !== handleCornerOptionClick || $[6] !== roundCornerValue || $[7] !== squareCornerValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, [
            {
                cornerOption: roundCornerValue,
                IconComponent: (0, $9l2Y4.RoundCornerIcon),
                label: (0, $4037714a7b5ad056$export$defe85febe8b728c).roundCornerStyleLabel
            },
            {
                cornerOption: squareCornerValue,
                IconComponent: (0, $2TDGa.SharpCornerIcon),
                label: (0, $4037714a7b5ad056$export$defe85febe8b728c).squareCornerStyleLabel
            }
        ].map((t4)=>{
            const { cornerOption: cornerOption_0, IconComponent: IconComponent, label: label } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                key: cornerOption_0,
                content: formatMessage(label)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($e3c7c5ec27e4fc8e$var$styles.borderOptionContainer, $e3c7c5ec27e4fc8e$var$styles.border, cornerStyleValue === cornerOption_0 && $e3c7c5ec27e4fc8e$var$styles.selected),
                onClick: ()=>handleCornerOptionClick(cornerOption_0),
                testId: `${cornerOption_0}${cornerStyleValue === cornerOption_0 ? "--selected" : ""}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                color: cornerStyleValue === cornerOption_0 ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                label: formatMessage(label)
            })));
        })));
        $[3] = cornerStyleValue;
        $[4] = formatMessage;
        $[5] = handleCornerOptionClick;
        $[6] = roundCornerValue;
        $[7] = squareCornerValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ cornerStyleValue: cornerStyleValue, updateCornerStyle: updateCornerStyle, roundCornerValue: roundCornerValue, squareCornerValue: squareCornerValue })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleCornerOptionClick = (cornerOption)=>updateCornerStyle(cornerOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4037714a7b5ad056$export$defe85febe8b728c).cornerStyle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, [
        {
            cornerOption: roundCornerValue,
            IconComponent: (0, $9l2Y4.RoundCornerIcon),
            label: (0, $4037714a7b5ad056$export$defe85febe8b728c).roundCornerStyleLabel
        },
        {
            cornerOption: squareCornerValue,
            IconComponent: (0, $2TDGa.SharpCornerIcon),
            label: (0, $4037714a7b5ad056$export$defe85febe8b728c).squareCornerStyleLabel
        }
    ].map(({ cornerOption: cornerOption_0, IconComponent: IconComponent, label: label })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: cornerOption_0,
            content: formatMessage(label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($e3c7c5ec27e4fc8e$var$styles.borderOptionContainer, $e3c7c5ec27e4fc8e$var$styles.border, cornerStyleValue === cornerOption_0 && $e3c7c5ec27e4fc8e$var$styles.selected),
            onClick: ()=>handleCornerOptionClick(cornerOption_0),
            testId: `${cornerOption_0}${cornerStyleValue === cornerOption_0 ? '--selected' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            color: cornerStyleValue === cornerOption_0 ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        })));
    })));
};
module.exports["CornerStyleConfig"] = $e3c7c5ec27e4fc8e$export$b2197740663fbf1;

});


//# sourceMappingURL=cards-extension.8ec851ff.js.map
